import { createSelector } from 'reselect'

const mcqSaveValidSelector = createSelector(
	[ state => state.creationTool.mcq ],
	mcqState => {
		const question = mcqState.question

		const questionEmpty = question.text === ''

		const answerEmpty = question.answers
			.findIndex(answer => answer.media.payload.text === '') !== -1

		const correctNotSelected = question.answers
			.findIndex(answer => answer.correct === true) === -1

		return !(questionEmpty || answerEmpty || correctNotSelected)
	}
)

export default mcqSaveValidSelector
